const KEY = 'tempusOidcOwner';
const EPOCH = 'tempusAuthOwner';
export const rotateAuthOwner = () => localStorage.setItem(EPOCH, Array.from(crypto.getRandomValues(new Uint32Array(4)), value => value.toString(16)).join('.'));
const fingerprint = async () => {
  const bytes = new TextEncoder().encode(localStorage.getItem('token') || '');
  return Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256', bytes)), value => value.toString(16).padStart(2, '0')).join('');
};
export const beginOidc = async () => {
  const token = await fingerprint();
  if (!localStorage.getItem(EPOCH)) rotateAuthOwner();
  sessionStorage.setItem(KEY, JSON.stringify({ token, owner: localStorage.getItem(EPOCH), started: Date.now() }));
};
export const claimOidcOwner = async () => {
  let owner;
  try { owner = JSON.parse(sessionStorage.getItem(KEY)); } catch { return null; }
  sessionStorage.removeItem(KEY);
  if (!owner || Date.now() - owner.started > 360000 || Date.now() < owner.started) return null;
  const owns = async () => {
    const token = await fingerprint();
    return owner.owner === localStorage.getItem(EPOCH) && owner.token === token;
  };
  return await owns() ? owns : null;
};
